import React from "react";
import { Card, Col } from "react-bootstrap";
import PieChartComponent from "../../chart/PieChart";
import { useTransition, useState, useEffect } from "react";
import LoadWraper from "components/LoadWraper";
import dashboard from "lib/deshboard-client";

const UserStatusCard = () => {
  const [userStats, setUserStats] = useState([]);
  const [totalUser, setTotalUser] = useState({});
  const [loadingUsers, startTansition] = useTransition();

  const fetchUserReports = async () => {
    const { statsArray, totalUser, error } = await dashboard.userReport()
    startTansition(() => {
      setUserStats(statsArray);
      setTotalUser({ totalUser } || {});
    });
  };

  useEffect(() => {
    fetchUserReports();
    return () => {
      setUserStats({ Active: 0, Inactive: 0 });
      setTotalUser({});
    };
  }, []);

  return (
    <Col md={6} className="h-100">
      <Card className="dashbaord-card">
        <Card.Body className="dashboard-card-body d-flex flex-column">
          <div className="d-flex justify-content-center align-items-center">
            <h4>Users</h4>
          </div>
          <div className="flex-grow-1 d-flex justify-content-center align-items-center">
            <LoadWraper isload={loadingUsers}>
              <PieChartComponent
                data={userStats}
                total={totalUser?.totalUser || 0}
                lable={"User"}
                colors={["#083458", "#8dd0e0"]}
              />
            </LoadWraper>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default React.memo(UserStatusCard);